'use client'

import type { ReactNode } from 'react'
import { Component } from 'react'
import { useTranslation } from '@/contexts/I18nContext'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

function DefaultFallback() {
  const { t } = useTranslation('app')
  return (
    <div className="p-4 bg-gray-800/40 rounded-lg border border-gray-700">
      <p className="text-gray-400">{t('App.ErrorBoundary.InvalidContent')}</p>
    </div>
  )
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('HTML rendering error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <DefaultFallback />
    }

    return this.props.children
  }
}

export default ErrorBoundary
